module.exports = __webpack_public_path__ + "static/img/1_4.f007344.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new/1_4.png
// module id = rcer
// module chunks = 0